<script setup lang="ts">
  import { inject } from 'vue';

  import { DESCRIPTION_LIST_INJECTION } from '../DescriptionList/DescriptionList.keys';

  const descriptionListInjectedValues = inject(DESCRIPTION_LIST_INJECTION.key);
  if (!descriptionListInjectedValues) {
    throw new Error('DescriptionListDetail must be used within a DescriptionList component.');
  }
  const { variant } = descriptionListInjectedValues;
</script>

<template>
  <dt
    class="stash-description-list-term flex items-center gap-x-1 font-semibold text-ice-900"
    :class="{
      'md:max-w-40 md:basis-2/5': variant === 'columns',
      'mr-1.5': variant === 'inline',
      'pb-1.5': variant === 'stacked',
      'pb-1.5 md:pb-0': variant !== 'stacked',
    }"
    data-test="stash-description-list-term"
    :data-variant="variant"
  >
    <!-- @slot Prepend slot, for rendering a prepended element -->
    <slot name="prepend"></slot>
    <!-- @slot Default slot, for rendering a term -->
    <slot></slot>
    <!-- @slot Append slot, for rendering an appended element -->
    <slot name="append"></slot>
  </dt>
</template>
